import { get } from 'lodash'
import { connect } from 'react-redux'

import { formData } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import { getFormMessages, getFormSettings, getIsGuestSignup, getTeamFormType } from '../../../../selectors'
import ParticipantsComponent from './component'

const mapStateToProps = state => ({
  members: get(state, 'formInfo.members'),
  registrations: get(state, 'formData.registrations'),
  isGuestSignup: getIsGuestSignup(state),
  memberOnly: get(state, 'formSettings.memberOnly'),
  organisation: get(state, 'formInfo.organisation'),
  info: get(state, 'formInfo.form'),
  welcomeMessages: getFormMessages(state).welcome,
  isTeamEvent: get(state, 'formInfo.event.isTeamEvent'),
  teamFormType: getTeamFormType(state),
  formSettings: getFormSettings(state),
  accountDetails: get(state, 'auth.user'),
})

export default connect(mapStateToProps, {
  selectParticipant: formData.selectParticipant,
})(withColorSetting(ParticipantsComponent))
